<template>
  <h1>Test UI for Feature Flags!</h1>
</template>
<script>
export default {
  name: "TestAdminUI"
}
</script>
<style scoped lang="sass">

</style>